// extracted by css-extract-rspack-plugin
export default {"elevated":"BJKzPV8PlWA1BW4v"};